<template>
  <div class="el-parameter-editor-item">
    <h1>{{ title }} ({{ replacerName }})</h1>
    <el-form inline label-position="top" class="el-parameter-editor-item-form" :model="current_value" ref="current_values" :rules="rules">
      <el-row :gutter="20" class="el-parameter-editor-item-form-row">
        <el-col>
          <el-form-item prop="currentValue" label="Выберите значение" class="el-form-editor-item">
            <el-slider
              v-model="current_value.value"
              :step="current_value.step"
              :min="current_value.min_value"
              :max="current_value.max_value"
              show-input
              @change="onChange"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item prop="isClientEditable">
            <el-checkbox
              size="small"
              true-label=1
              false-label=0
              :checked="current_value.isClientEditable==1"
              v-model="current_value.isClientEditable"
              @change="onChange"
            >Доступно клиенту для редактирования</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>

import {required, validatorNumber} from "@/core/helpers/validators"

export default {
  name: "RangeEditor",
  props: {
    title: {
      type: String,
      default: "Заголовок",
    },
    replacerName: {
      type: String,
      default: "#replacer",
    },
    currentValue: {
      type: Object,
      default: function() {},
    },
  },
  data() {
    return {
      current_value: this.currentValue,
      rules: {
        current_value: [required(), validatorNumber],
      }
    }
  },
  mounted() {
    this.$refs['current_values'].validate();
  },
  beforeDestroy() {
    this.onDelete();
  },
  methods: {
    onChange() {
      const diff = this.current_value.value % this.current_value.step
      if (diff !== 0)
        this.current_value.value += this.current_value.step - diff

      this.$emit("updateValues", {
        replacer: this.replacerName,
        current_value: this.current_value,
        is_client_editable: this.current_value.isClientEditable
      });
    },
    onDelete() {
      this.$emit("removeEditor", {
        replacer: this.replacerName,
      });
    },
  },
};
</script>

<style>
div .el-parameter-editor-item {
  border: thin solid #3883fa;
  margin-top: 5px;
  padding: 0 10px;
}

.el-parameter-editor-item-form {
  max-width: 100%;
}

.el-parameter-editor-item-form-row {
  display: flex;
  justify-content: space-around;
}

.el-form-editor-item {
  width: 100%;
}
</style>
